import { COLUMN_WIDTHS } from "../../constants/ApplicationConstants";
import infoIcon from "../../../assets/icons/info_white.svg";
import { Tooltip } from "primereact/tooltip";
import onGoCarIcon from "../../assets/icons/onGoCar.png";
import coinIcon from "../../assets/icons/coin_icon.svg";
import moreIcon from "../../assets/icons/more.png";
import adaptiveSpeaker from "../../assets/icons/adaptive_speaker.svg";
import { handleAddPage } from "../C4S Decommission - Replacement/utils";
import { ViewVehicleDetailsMetadata } from "../C4S Decommission - Replacement/ViewVehicleDetailsMetadata";
import VehicleActionsMenu from "./VehicleActionsMenu";
import { COLORS, TOOLTIP_MESSAGES } from "./VehicleManagementConstants";
import WarningIcon from "../../assets/icons/warning.png";
import {
  VehicleRow,
  VehicleIcon,
  VehicleInfoWrapper,
  VehicleNameLinkButton,
  VehicleNameRow,
  VehicleSubText,
  TraitsRow,
  InstallTypeRow,
  NotBilledIconWrapper,
  ConvertedLabel,
  TooltipText,
  VehicleNoteHeaderWrapper,
  InfoIconImg,
  TruncatedText,
  CoinImg,
  StrikeThroughLine,
  Badge,
  IconWithTooltip,
} from "./VehicleManagementGrid.styles";

const ROW_CELL_STYLE = { background: "#F8F7F5", fontSize: "12px" };

export const VEHICLE_DETAIL_COL = [
  {
    key: "Vehicle/Asset",
    value: "vehicleData",
    minWidth: "220px", // Minimum width
    width: COLUMN_WIDTHS.medium,
    cellStyle: ROW_CELL_STYLE,
    renderCell: (row, _value, ctx) => {
      const disabled = !!ctx?.isSelectionEnabled || !!ctx?.isBulkBarOpen;
      const onOpen = (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        if (disabled) return;
        handleAddPage(ViewVehicleDetailsMetadata.id, {
          data: row,
          description: row?.vehicleName ?? row?.vehicle ?? "Vehicle Details",
          mode: "view",
          returnTo: "vehicle-management",
        });
      };
      const nameLink = (label) => (
        <VehicleNameLinkButton type="button" onClick={onOpen} disabled={disabled} aria-label="Open vehicle details">
          {label}
        </VehicleNameLinkButton>
      );

      return row.assetType === "Vehicle" ? (
        <VehicleRow>
          <VehicleIcon src={onGoCarIcon} alt="on-go-car-icon" height={25} width={25} />
          <VehicleInfoWrapper>
            <VehicleNameRow>{nameLink(`${row.year} ${row.make} ${row.model}`)}</VehicleNameRow>
            <VehicleSubText>{row.vehicle.startsWith("VIN") ? "" : row.vehicle} </VehicleSubText>
            <VehicleSubText $gap="8px">{row.weightClass}</VehicleSubText>
            <TraitsRow>
              {/* Traits icons side by side */}
              {row.wheelChair && (
                <IconWithTooltip
                  id={`wheelchair-icon-${row.id}`}
                  iconName="international-symbol-of-access"
                  tooltipContent={TOOLTIP_MESSAGES.WHEELCHAIR}
                  tooltipPosition="top"
                />
              )}
              {row.emergency && (
                <IconWithTooltip
                  id={`emergency-icon-${row.id}`}
                  iconName="police-fleet"
                  tooltipContent={TOOLTIP_MESSAGES.EMERGENCY}
                  tooltipPosition="top"
                />
              )}
              {row.killSwitch && (
                <IconWithTooltip
                  id={`killswitch-icon-${row.id}`}
                  iconName="smart-switch"
                  tooltipContent={TOOLTIP_MESSAGES.KILLSWITCH}
                  tooltipPosition="top"
                />
              )}
              {row.isCompetitor && (
                <IconWithTooltip
                  id={`competitor-device-${row.id}`}
                  iconName="router"
                  tooltipContent={row.isCompetitorComplete ? TOOLTIP_MESSAGES.COMPETITOR_DEVICE_REMOVED : TOOLTIP_MESSAGES.COMPETITOR_DEVICE}
                  tooltipPosition="top"
                  wrapperColor={row.isCompetitorComplete ? COLORS.COMPETITOR_COMPLETE : COLORS.COMPETITOR_INCOMPLETE}
                />
              )}
            </TraitsRow>
          </VehicleInfoWrapper>
        </VehicleRow>
      ) : (
        <VehicleRow>
          <VehicleIcon src={adaptiveSpeaker} alt="adaptive-speaker-icon" height={25} width={25} />
          <VehicleInfoWrapper>
            <VehicleNameRow>
              {nameLink(
                row.year ? `${row.year} ${row.make} ${row.model}` : `${row.iconCategory?.startsWith("Non") ? "Non Powered Asset" : "Powered Asset"}`
              )}
            </VehicleNameRow>
            <VehicleSubText>{row.vehicle?.startsWith("AST") ? "" : row.vehicle} </VehicleSubText>
            <TraitsRow>
              {/* Traits icons side by side */}
              {row.isCompetitor && (
                <IconWithTooltip
                  id={`competitor-device-${row.id}`}
                  iconName="router"
                  tooltipContent={row.isCompetitorComplete ? TOOLTIP_MESSAGES.COMPETITOR_DEVICE_REMOVED : TOOLTIP_MESSAGES.COMPETITOR_DEVICE}
                  tooltipPosition="top"
                  wrapperColor={row.isCompetitorComplete ? COLORS.COMPETITOR_COMPLETE : COLORS.COMPETITOR_INCOMPLETE}
                />
              )}
            </TraitsRow>
          </VehicleInfoWrapper>
        </VehicleRow>
      );
    },
  },
  {
    key: "Name",
    value: "vehicleName",
    cellStyle: ROW_CELL_STYLE,
  },
  {
    key: "License Plate",
    value: "licensePlate",
    cellStyle: ROW_CELL_STYLE,
  },
  {
    key: "Inst. Type",
    value: "installType",
    cellStyle: ROW_CELL_STYLE,
    renderCell: (row) => {
      return (
        <div>
          <InstallTypeRow>
            <span>{row.installType ? (row.installType.startsWith("VMI") ? "VMI" : "CMI") : "--"}</span>
            {row.installType && row.installType?.startsWith("VMI") ? (
              <span>
                {row.isBillable !== null ? (
                  row.isBillable ? (
                    <CoinImg src={coinIcon} alt="coin-info-icon" width={13} height={13} />
                  ) : (
                    <NotBilledIconWrapper>
                      <CoinImg id={`install-type-tooltip-${row.id}`} src={coinIcon} alt="coin-icon" width={13} height={13} />
                      <StrikeThroughLine />
                      <Tooltip target={`#install-type-tooltip-${row.id}`} position="top">
                        <TooltipText>
                          <strong>Not Billed</strong> <br />
                          <strong>Reason:</strong> <span>{row.billableReason}</span>
                        </TooltipText>
                      </Tooltip>
                    </NotBilledIconWrapper>
                  )
                ) : (
                  <></>
                )}
              </span>
            ) : (
              <></>
            )}
          </InstallTypeRow>
          <ConvertedLabel>{["VMIC", "CMIC"].includes(row.installType) ? "(Converted)" : ""}</ConvertedLabel>
        </div>
      );
    },
  },
  {
    key: "Vehicle Note",
    value: "vehicleNote",
    width: COLUMN_WIDTHS.small,
    cellStyle: ROW_CELL_STYLE,
    renderHeader: () => (
      <VehicleNoteHeaderWrapper>
        <span>Vehicle Note</span>
        <InfoIconImg id="vehicle-note-tooltip" src={infoIcon} alt="info-icon" width={14} height={14} />
        <Tooltip target="#vehicle-note-tooltip" content="This note will be presented to the technician on RHI" position="top" />
      </VehicleNoteHeaderWrapper>
    ),
    renderCell: (row) => {
      return <TruncatedText title={row.vehicleNote}>{row.vehicleNote || "--"}</TruncatedText>;
    },
  },
  {
    key: "Shipping Status",
    value: "shippingStatus",
    cellStyle: ROW_CELL_STYLE,
    renderCell: (row) => {
      return (
        <div>
          {row.shippingStatus ? (
            <>
              <Badge>{row.shippingStatus}</Badge>
              {/* add delivery dates here */}
              <div></div>
            </>
          ) : (
            <div>--</div>
          )}
        </div>
      );
    },
  },
  {
    key: "Inst. Status",
    value: "installStattus",
    cellStyle: ROW_CELL_STYLE,
    renderCell: (row) => {
      return (
        <div>
          <div>{row.installStatus || "--"}</div>
          {row.needsQA ? (
            <div style={{ color: "#FF8027", gap: "4px", paddingTop: "4px" }}>
              <img src={WarningIcon} alt="warning-icon" width={12} height={12} />
              <span style={{ paddingLeft: "4px" }}>Needs QA</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      );
    },
  },
  {
    key: "Appointment Address",
    value: "appointmentAddress",
    cellStyle: ROW_CELL_STYLE,
  },
];

/**
 * Standalone rowActions renderer for use via the `rowActions` prop of NewGridComponent.
 * Renders the three-dots VehicleActionsMenu for each row.
 */
export const vehicleRowActions = (row, ctx) => {
  const selectionDisabled = !!ctx?.isSelectionEnabled || !!ctx?.isBulkBarOpen;

  const assetType = String(row?.assetType ?? "")
    .trim()
    .toUpperCase();
  const iconCategory = String(row?.iconCategory ?? "")
    .trim()
    .toUpperCase();

  const isNonPowered = iconCategory.includes("NON");

  const isVehicleOrAsset = assetType === "VEHICLE" || assetType === "ASSET";
  const iconCategoryAllowed = iconCategory.length === 0 ? true : !isNonPowered;
  const eligibleForActions = isVehicleOrAsset && iconCategoryAllowed;

  return (
    <VehicleActionsMenu
      row={row}
      disabled={selectionDisabled || !(eligibleForActions || isNonPowered)}
      triggerIcon={moreIcon}
      showViewDetails={isVehicleOrAsset}
      hideEdit={isNonPowered}
      hideReplace={isNonPowered}
    />
  );
};
